import React from 'react';
import { ScaleLoader } from 'react-spinners';


export const Loader = () => (
  <div className="loader">
    <ScaleLoader color="#FFBA38" sizeUnit="px" size={70} />
  </div>
);
